// Step 1-A — 운영 path 통합 진입점.
//
// 한 번 호출 시:
//   1. DI-1 auditIntentionDimensions — 65 entries integrity 검증
//   2. DI-2 auditMigrationMap — 32 patch mapping integrity 검증
//   3. CL-2 registerOrphanRecoveryHandler — tool_result_missing handler 등록
//   4. CL-3 registerEmptyMessageRecoveryHandler — empty_message handler 등록
//
// idempotent — 두 번 호출 시 첫 결과 그대로 반환 (handler 중복 register X).
//
// 회귀 위험 0 — register만 함 (실제 dispatch는 후속 step 1-C catch 분기에서).
//
// 사용:
//   import { bootAgent } from '/Agent/boot.js';
//   bootAgent();  // useAiChat / nodeAgent 진입점에서 1회 호출

import { auditIntentionDimensions } from './Routing/intentionAdapter.js';
import { auditMigrationMap } from './MIGRATION.js';
import { registerOrphanRecoveryHandler } from './Recovery/repairOrphanedToolCalls.js';
import { registerEmptyMessageRecoveryHandler } from './Recovery/injectPlaceholderForEmpty.js';

let _booted = false;
let _bootResult = null;

/**
 * Agent boot — audit + register handler. idempotent.
 *
 * @param {object} [options]
 * @param {boolean} [options.silent=false] — true면 audit fail 시 console.warn 생략 (test용)
 * @returns {{
 *   booted: true,
 *   firstBoot: boolean,
 *   adapterAudit: {valid, errors, total},
 *   migrationAudit: {valid, errors},
 *   handlersRegistered: {orphan, empty}
 * }}
 */
export function bootAgent(options = {}) {
  if (_booted) {
    return { ..._bootResult, firstBoot: false };
  }
  _booted = true;

  const silent = !!options.silent;

  const adapterAudit = auditIntentionDimensions();
  const migrationAudit = auditMigrationMap();
  const orphanRegistered = registerOrphanRecoveryHandler();
  const emptyRegistered = registerEmptyMessageRecoveryHandler();

  _bootResult = {
    booted: true,
    adapterAudit,
    migrationAudit,
    handlersRegistered: {
      orphan: orphanRegistered,
      empty: emptyRegistered,
    },
  };

  if (!silent) {
    if (!adapterAudit.valid) {
      // eslint-disable-next-line no-console
      console.warn('[bootAgent] INTENTION_DIMENSIONS audit failed:', adapterAudit.errors);
    }
    if (!migrationAudit.valid) {
      // eslint-disable-next-line no-console
      console.warn('[bootAgent] MIGRATION map audit failed:', migrationAudit.errors);
    }
  }

  return { ..._bootResult, firstBoot: true };
}

export function isBooted() {
  return _booted;
}

/**
 * 테스트 전용 — boot 상태 reset. 운영 path는 호출 X.
 */
export function _resetBootForTest() {
  _booted = false;
  _bootResult = null;
}
